import { useHistory, useLocation } from 'react-router-dom'
import { IconArrowLeft } from '../../../assets/icons'
import { useAppParamsContext } from '../../../context/AppParamsContext'
import { CURRENT_APP_MODE_CONFIG } from '../../../constants/appMode'
import { PATH } from '../../../constants/router'
import { decodeLink } from '../../../helper/params'
import './index.scss'

export default function HeaderPartner({ title, noBackground = false, onGoBack }) {
  const history = useHistory()
  const { pathname, state } = useLocation()
  const { isEmbeddedView, backToHomeMiniAppUrlParam } = useAppParamsContext()

  // Check if embedded view - hide header
  if (isEmbeddedView) {
    return null
  }

  const headerBackgroundStyle = CURRENT_APP_MODE_CONFIG.headerBackgroundImage
    ? { backgroundImage: `url(${CURRENT_APP_MODE_CONFIG.headerBackgroundImage})` }
    : undefined

  return (
    <div className={`HeaderPartner ${CURRENT_APP_MODE_CONFIG.headerClassName}`}>
      <div className="HeaderPartner_fixed">
        {!noBackground && (
          <div
            className="HeaderPartner_fixed_bg"
            style={headerBackgroundStyle}
          />
        )}

        <div className="HeaderPartner_fixed_content">
          <IconArrowLeft
            className={`${noBackground ? 'iconDark' : ''}`}
            onClick={() => {
              const rootPaths = [
                PATH.HOME,
                PATH.AUTO_TRAFFIC_FINE_NOTIFICATION_LOOKUP,
                PATH.AUTO_TRAFFIC_FINE_NOTIFICATION_INTRODUCE
              ]
              const isRootMiniAppPath = rootPaths.includes(pathname) && !state?.canGoBack

              if (isRootMiniAppPath && backToHomeMiniAppUrlParam) {
                window.location.href = decodeLink(backToHomeMiniAppUrlParam)
                return
              }

              if (onGoBack) {
                onGoBack()
              } else {
                history.goBack()
              }
            }}
          />
          <div className="HeaderPartner_fixed_content_title">{title}</div>
          <div className="HeaderPartner_fixed_content_right"></div>
        </div>
      </div>
      <div className="HeaderPartner_padding"></div>
    </div>
  )
}